import { createInstance } from './config';

const BASE_URL = '/products';

export const getFlowAndProductByCompanyIdAndProductName = async (companyId, productName) => {
  const axios = createInstance();
  const { data } = await axios.get(`${BASE_URL}/company/${companyId}/productname/${productName}`);
  return data;
};
